import React, { useState } from 'react';
import Projects from './Projects';

function ProjectsPage() {
  const [category, setCategory] = useState('spotify');
  return <Projects selectedCategory={category} setCategory={setCategory} />
}

export default ProjectsPage;